module.exports = __webpack_public_path__ + "static/media/3d-product-icon.282b8670.svg";